import {Component, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {RouterOutlet} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {SvgIconComponent} from 'angular-svg-icon';

@Component({
    selector: 'app-password-validation-rules',
    templateUrl: './password-validation-rules.component.html',
    styleUrls: ['./password-validation-rules.component.scss'],
    standalone: true,
    imports: [
        RouterOutlet,
        TranslateModule,
        SvgIconComponent
    ]
})
export class PasswordValidationRulesComponent
{
    public passwordControl = input.required<FormControl>();

    public readonly focused = input<boolean>(false);
}
